<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"  @click="$router.push('/production-add')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
      <!-- Shop-floor analysis: barcodes scanned with XYLO PRD / logs seen by the XYLO VISION EW1 camera -->
      <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="$router.push('/production/analysis')">
        <feather-icon icon="TagIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Barcode analysis</span>
      </div>
      <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="$router.push('/production/analysis-camera')">
        <feather-icon icon="VideoIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Camera analysis</span>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ operationsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : operationsData.length }} of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!--<vs-button v-if="displayExport != false" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export Table as CSV</vs-button>-->
          <vs-button icon-pack="feather" icon="icon-download-cloud" v-if="displayExport != false" class="mb-4 md:mb-0 ml-4" @click="downloadFullReport">Export Report XLS</vs-button>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="operationsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {
      displayExport: false,
     searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          valueGetter: function(params) {
            return '#'+params.data.nameorid
          },
          //field: 'iscompany',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Date',
          valueGetter: function(params) {
            return params.data.creation
          },
          //field: 'iscompany',
          sort:'DESC',
          filter: true,
          width: 150
        },
        {
          headerName: 'Product Category',
          field: 'category_name',
          filter: true,
          width: 300
        },
        {
          headerName: 'Production (m3)',
          valueGetter: function(params) {
            if (params.data.creation_of_waste) return (parseFloat(params.data.volume)-parseFloat(params.data.creation_of_waste)).toFixed(4)
            else if (params.data.volume) return parseFloat(params.data.volume).toFixed(4)
            else return '-'
          },
          field: 'volume',
          filter: true,
          width: 180,
          type: 'numericColumn'
        },
        {
          headerName: 'Waste/Firewood (m3)',
          valueGetter: function(params) {
            if (params.data.creation_of_waste) return parseFloat(params.data.creation_of_waste).toFixed(4)
          },
          field: 'waste',
          filter: true,
          width: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'Weight (t)',
          valueGetter: function(params) {
            if (params.data.weight) return parseFloat(params.data.weight).toFixed(4)
          },
          field: 'waste',
          filter: true,
          width: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'Sync Saga',
          valueGetter: function(params) {
            if (params.data.issyncsaga) return params.data.issyncsaga
            else return false
          },
          field: 'Sync Saga',
          filter: true,
          width: 150,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: 'Internal Note',
          valueGetter: function(params) {
            if (params.data.sumal_aviz_nr) return params.data.sumal_aviz_nr
            else if (params.data.mail_top) return params.data.mail_top
            else return "N/A"
          },
          field: 'Aviz No',
          filter: true,
          width: 240,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 120,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsData () {
      return this.$store.state.operationList.operations
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    downloadFullReport()
    {
      window.location.href = 'https://xylo.codesinn.com/api/kpi/14/d86f4d7f-65d3-413e-aed4-2ae3816d5145';
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  created () {
    this.$vs.loading()
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.$store.dispatch('operationList/fetchProductions')
    .then(response => {
      this.$vs.loading.close()
    })
    .catch(err => { console.error(err) })
  }
}
</script>


